<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" label-position="left" @submit.native.prevent>
            <el-form-item label="查看下级：">
                <el-select v-model="searchForm.seeAll" clearable>
                    <el-option value="100" label="所有申请"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.oldIccid" @keyup.enter.native="getBuyCardOrderList" clearable></el-input>
            </el-form-item>

            <el-form-item label="订单状态：">
                <el-select v-model="searchForm.payState" clearable>
                    <el-option label="待支付" value="0"></el-option>
                    <el-option label="已支付" value="1"></el-option>
                    <el-option label="已退款" value="3"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="下单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getBuyCardOrderList">查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData"
		  border
		  fit
		  highlight-current-row
		  style="width: 100%;"
		  :header-cell-style="{background:'#f5f5f5'}"
		  > 
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="id" label="订单号"  align="center"></el-table-column>
            <el-table-column prop="pay_no" label="第三方支付单号"  align="center"></el-table-column>
            <el-table-column prop="iccid" label="ICCID号"  align="center"></el-table-column>
            <el-table-column label="支付金额(元)" width="120" align="center">
                <template v-slot='scope'  style="color:hotpink">
                    {{ scope.row.price/100 }}
                </template>
            </el-table-column>
            <el-table-column prop="agent_name" label="代理商名称" width="120" align="center"></el-table-column>
            <el-table-column prop="agent_path_name" label="代理商层级" width="150" align="center"></el-table-column>
            <!-- <el-table-column prop="payName" label="支付状态" width="120" align="center"></el-table-column> -->
            <el-table-column  align="center"  label="支付状态" width="70">
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.payState==1" class="item" effect="dark" :content="scope.row.payNo">
                        <p style="color:green"> {{scope.row.payName}}</p>
                    </el-tooltip>
                  <el-tooltip v-else-if="scope.row.payState==3||scope.row.payState==4" class="item" effect="dark" :content="scope.row.payNo">
                        <p style="color:red"> {{scope.row.payName}}</p>
                    </el-tooltip>
                    <el-tooltip v-else class="item" effect="dark" :content="scope.row.payNo">
                        <p style="color:teal"> {{scope.row.payName}}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="下单时间" width="150" align="center"></el-table-column>
            <el-table-column label="操作" width="80" align="center" fixed="right">
                <template v-slot="scope" >
                    <el-button v-if="scope.row.pay_state != 3" type="text" size="small" @click="refund(scope.row)">
						<span style="color:red;">退 款</span>
					</el-button>
                </template>                
            </el-table-column>
        </el-table>

        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 

    
    </div>
</template>
<script>
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                iccid: '',
                time:'',
                payState: '',
                seeAll: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            }
        }
    },
    methods: {
        getBuyCardOrderList($event){
            // if(this.searchForm.seeAll == ''){
            //     this.$message.error('请先选择查看下级');
            //     return;
            // }
            common.resetCurrentPage(this, $event, 'tbpg');
            let data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest("bindPhone/buy/sim/order", data, 'post').then(res=>{
                common.listCallback(this, res, 'tbpg');
            })
        },
        
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getBuyCardOrderList();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val
            this.getBuyCardOrderList();
        },        

        refund(row){
            this.$confirm('确定退款吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
            }).then(() => {
                let data = {
                    price: row.price,
                    id: row.id
                }
                common.sysRequest("bindPhone/back/money/price", data, 'post').then(res=>{
                    if(res.data.code == 200){
                        this.getBuyCardOrderList();
                        this.$message.success(res.data.message);
                    }else{
                        this.$message.error(res.data.message)
                    }     
                })

            }).catch(() => {});
            
        },
    },
    created(){
        this.getBuyCardOrderList();
    }
}
</script>
<style lang="less" scoped>

</style>

